import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import store from "./store";
import helper from "./helper";
import Multiselect from "vue-multiselect";
import "@/assets/css/multiselect-bs4.css";
import "@/assets/scss/_variables.scss";

/// ===== LOCAL DEV
// const BASE_API_PATH = "https://api.ecom.sm.dev.inergi.id/api/";
// const BASE_FILE_PATH = "https://api.ecom.sm.dev.inergi.id";
// const BASE_PRINT_FILE_PATH = "https://api.ecom.sm.dev.inergi.id";

const BASE_API_PATH = "https://api.sm-ecomm-dev.pgindonesia.com/api/";
const BASE_FILE_PATH = "https://api.sm-ecomm-dev.pgindonesia.com";
const BASE_PRINT_FILE_PATH = "https://api.sm-ecomm-dev.pgindonesia.com";

// const BASE_API_PATH = "https://api.ecom.sm.dev.inergi.id/api/";
// const BASE_FILE_PATH = "https://api.ecom.sm.dev.inergi.id";
// const BASE_PRINT_FILE_PATH = "https://api.ecom.sm.dev.inergi.id";

/// ===== PRODUCTION
// const BASE_API_PATH = "https://ignis.penjualan.pugindo.com/api/"
const BASE_FILE_PATH_PROD =
    "https://sinarmutiaracell.sgp1.digitaloceanspaces.com";
// const BASE_PRINT_FILE_PATH = "https://ignis.penjualan.pugindo.com"

// const BASE_API_PATH = "http://localhost:8000/api/"
// const BASE_FILE_PATH = "http://localhost:8000"
// const BASE_PRINT_FILE_PATH = "http://localhost:8000"

// file upload size limit at 5242880 bytes or 5 MB
const UPLOAD_LIMIT = 5242880;

var axiosAbsensi = axios.create({
    baseURL: BASE_API_PATH,
});

axiosAbsensi.defaults.baseURL = BASE_API_PATH;
axiosAbsensi.defaults.timeout = 180000;
axiosAbsensi.defaults.headers.post["Accept"] = "application/json";
axiosAbsensi.defaults.headers.common["Authorization"] =
    localStorage.getItem("token") || "";
axiosAbsensi.defaults.headers.common["LoginTime"] =
    localStorage.getItem("loginTime") || "";

// Interceptors for 401 responses (unauthorized)
axiosAbsensi.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        console.log(error.response);

        if (error.response && error.response.status == 401) {
            axiosAbsensi.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login");
        } else if (error.response && error.response.status == 402) {
            axiosAbsensi.defaults.headers.common["Authorization"] = "";
            var version = localStorage.getItem("version");
            localStorage.clear();
            localStorage.setItem("version", version);

            router.push("/login?error=true");
        }

        return Promise.reject(error);
    }
);

Vue.use(BootstrapVue);
Vue.component("multiselect", Multiselect);
Vue.prototype.$axios = axiosAbsensi;
Vue.prototype.$helper = helper;
Vue.prototype.$BASE_FILE_PATH = BASE_FILE_PATH;
Vue.prototype.$BASE_FILE_PATH_PROD = BASE_FILE_PATH_PROD;
Vue.prototype.$BASE_PRINT_FILE_PATH = BASE_PRINT_FILE_PATH;
Vue.prototype.$uploadLimit = UPLOAD_LIMIT;

/// GLOBAL COMPONENTS
/// Base components
const requireComponent = require.context(
    "./globals",
    false,
    /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    let compName = fileName.includes("Loading") ? "LoadingWidget" : "PageSizer";

    Vue.component(compName, componentConfig.default || componentConfig);
});

new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: {
        App,
    },
});
